/*
  Bonny & Rose: de kleur van het bolletje op de kaart laten zien.

  Elke kleur is een eigen product met een eigen foto, en op een kaart in de
  collectie staat er maar één van. De andere kleuren staan eronder als bolletjes.
  Een bolletje van twintig pixels vertelt weinig over hoe een jurk in die kleur
  eruitziet, dus wie er met de muis overheen gaat, krijgt hier de foto van die
  kleur over de kaart te zien. De muis weg, de eigen foto terug.

  Waarom een tweede foto er overheen en niet de bron van de eerste vervangen:
  het thema zet op die foto een hele reeks maten via srcset. Alleen de bron
  omzetten doet dan niets, en de reeks overschrijven zou de scherpte op grote
  schermen kapotmaken. Een tweede foto erover laat de eerste met rust en kan
  rustig invagen.

  Op een telefoon gebeurt dit niet: daar is een tik een klik, en die brengt de
  bezoeker gewoon naar het kleurproduct zelf.
*/
(function () {
  'use strict';

  function kaartVan(bol) {
    return bol.closest ? bol.closest('.grid-product') : null;
  }

  function laag(kaart) {
    var masker = kaart.querySelector('.grid-product__image-mask');
    if (!masker) return null;
    var img = masker.querySelector('.br-card-swap');
    if (!img) {
      img = document.createElement('img');
      img.className = 'br-card-swap';
      img.setAttribute('alt', '');
      img.setAttribute('aria-hidden', 'true');
      img.setAttribute('loading', 'lazy');
      masker.appendChild(img);
    }
    return img;
  }

  function toon(bol) {
    var bron = bol.getAttribute('data-br-foto');
    var kaart = kaartVan(bol);
    if (!bron || !kaart) return;
    var img = laag(kaart);
    if (!img) return;
    if (img.getAttribute('src') !== bron) img.setAttribute('src', bron);
    img.classList.add('is-zichtbaar');
  }

  function verberg(kaart) {
    var img = kaart && kaart.querySelector('.br-card-swap');
    if (img) img.classList.remove('is-zichtbaar');
  }

  document.addEventListener('mouseover', function (e) {
    var bol = e.target.closest && e.target.closest('.br-card-color');
    if (bol) toon(bol);
  });

  document.addEventListener('mouseout', function (e) {
    var bol = e.target.closest && e.target.closest('.br-card-color');
    if (!bol) return;
    /* Van het ene bolletje naar het volgende telt niet als weggaan: anders
       knippert de foto tussen twee kleuren in. */
    var naar = e.relatedTarget && e.relatedTarget.closest ? e.relatedTarget.closest('.br-card-color') : null;
    if (naar && kaartVan(naar) === kaartVan(bol)) return;
    verberg(kaartVan(bol));
  });
})();
